import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Entity} from '../../entity/entity';
import {OrderService} from '../../services/order-service';
import {QuoteService} from '../../services/quote-service';
import {MatButton} from '@angular/material/button';
import {FormsModule} from '@angular/forms';
import {MatInput} from '@angular/material/input';
import {MatFormField, MatLabel} from '@angular/material/form-field';

@Component({
    selector: 'app-enter-contact-dialog',
    templateUrl: './enter-contact-dialog.component.html',
    styleUrls: ['./enter-contact-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatFormField,
        MatLabel,
        MatInput,
        FormsModule,
        MatButton,
    ]
})
export class EnterContactDialogComponent {
  private readonly quoteService = inject(QuoteService);
  private readonly orderService = inject(OrderService);
  private readonly dialogRef = inject<MatDialogRef<EnterContactDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);

  errorMessage!: string
  isBusy!: boolean;
  isPrimaryContact: boolean;
  isEntityFrozen: boolean;
  entity: Entity;
  deliveryContactName: string;
  deliveryPhone: string;

  constructor() {
    this.isEntityFrozen = this.data.entity.frozen;
    this.isPrimaryContact = this.data.isPrimaryContact;
    this.entity = JSON.parse(JSON.stringify(this.data.entity));
    if (this.data.isPrimaryContact) {
      this.deliveryContactName = this.data.entity.deliveryContactName;
      this.deliveryPhone = this.data.entity.deliveryPhone;
    } else {
      this.deliveryContactName = this.data.entity.deliveryContactName2;
      this.deliveryPhone = this.data.entity.deliveryPhone2;
    }
  }

  submit(): void {
    if (this.isPrimaryContact) {
      this.entity.deliveryContactName = this.deliveryContactName;
      this.entity.deliveryPhone = this.deliveryPhone;
    } else {
      this.entity.deliveryContactName2 = this.deliveryContactName;
      this.entity.deliveryPhone2 = this.deliveryPhone;
    }
    if (this.entity.id.entityName === 'QUOTE') {
      this.quoteService.save(this.entity).subscribe({
        next: result => this.dialogRef.close(result.updated),
        error: error => this.dialogRef.close(error)
      });
    } else if (this.entity.id.entityName === 'CONTRACT') {
      this.orderService.save(this.entity).subscribe({
        next: result => this.dialogRef.close(result.updated),
        error: error => this.dialogRef.close(error)
      })
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
